/**
 * useModalState - 모달 상태 감지 훅
 * 
 * DOM을 관찰하여 모달이 열려있는지 감지합니다.
 * 플로팅 메뉴 숨김 처리에 사용
 */
import { useState, useEffect } from 'react';

export default function useModalState() {
    const [isModalOpen, setIsModalOpen] = useState(false);

    useEffect(() => {
        const checkModalState = () => {
            const modalOverlays = document.querySelectorAll(
                '[class*="modalOverlay"], [style*="position: fixed"][style*="z-index"]'
            );
            const hasModal = Array.from(modalOverlays).some(overlay => {
                const style = window.getComputedStyle(overlay);
                if (
                    style.display === 'none' ||
                    style.visibility === 'hidden' ||
                    style.opacity === '0'
                ) {
                    return false;
                }

                const className = typeof overlay.className === 'string' ? overlay.className : '';
                const isExplicitModal = className.includes('modalOverlay');

                if (!isExplicitModal && style.pointerEvents === 'none') {
                    return false;
                }

                return true;
            });
            setIsModalOpen(hasModal);
        };

        checkModalState();
        const interval = setInterval(checkModalState, 100);

        const observer = new MutationObserver(checkModalState);
        observer.observe(document.body, {
            childList: true,
            subtree: true,
            attributes: true,
            attributeFilter: ['style', 'class']
        });

        return () => {
            clearInterval(interval);
            observer.disconnect();
        };
    }, []);

    return isModalOpen;
}
